import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from '@/core/routes'
import { requirePublic } from '@/core/lib/route-guards'

import {
  resetTokenSearchSchema,
  signOutStatusSchema,
} from '@/modules/auth/auth.schemas'
import AuthLayout from '@/modules/auth/pages/auth-layout.page'

export const authRoute = createRoute({
  id: 'authLayout',
  getParentRoute: () => rootRoute,
  component: AuthLayout,
})

export const signInRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/',
  validateSearch: signOutStatusSchema,
  beforeLoad: requirePublic,
  head: () => ({ meta: [{ title: 'Giriş Yap' }] }),
  component: lazyRouteComponent(
    () => import('@/modules/auth/pages/sign-in.page')
  ),
})

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/forgot-password',
  beforeLoad: requirePublic,
  head: () => ({ meta: [{ title: 'Şifremi Unuttum' }] }),
  component: lazyRouteComponent(
    () => import('@/modules/auth/pages/forgot-password.page')
  ),
})

export const resetPasswordRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/reset-password',
  validateSearch: resetTokenSearchSchema,
  beforeLoad: requirePublic,
  head: () => ({ meta: [{ title: 'Şifreyi Sıfırla' }] }),
  component: lazyRouteComponent(
    () => import('@/modules/auth/pages/reset-password.page')
  ),
})
